import { render, staticRenderFns } from "./IAmNotReadyButton.vue?vue&type=template&id=ab6df844"
import script from "./IAmNotReadyButton.vue?vue&type=script&lang=js"
export * from "./IAmNotReadyButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports